/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-data-text-link-analysis': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M5 6.25h5V7.5H5V6.25zm0-2.5h7.5V5H5V3.75zm0-2.5h7.5V2.5H5V1.25zM2.944 17.5l3.52-6.248 4.646 4.057a1.25 1.25 0 001.928-.334l4.356-6.502-1.038-.696-4.375 6.53-.044.064-4.647-4.056a1.252 1.252 0 00-1.925.331L2.5 15.74V1.25H1.25V17.5c0 .69.56 1.25 1.25 1.25h16.25V17.5H2.944z"/>'
  }
})
